<section class="">
  <div class="mx-auto w-full max-w-[90rem] p-5 md:px-8">
    <div class="flex flex-col items-center justify-between gap-4 lg:flex-row">
      <h1 class="flex">Unusual Network Metrics</h1>

      <div class="flex flex-row flex-wrap items-center justify-center gap-2">
        <div
          class="flex h-14 items-center justify-center rounded-full bg-white px-4 pb-0.5 pt-2 lg:ml-2"
        >
          <app-toggle
            [disabled]="isLoading"
            [(ngModel)]="showMockData"
            (ngModelChange)="toggleMockData($event)"
            [label]="
              showMockData ? 'Switch to Real Data' : 'Switch to Sample Data'
            "
            size="md"
            color="primary"
          >
          </app-toggle>
        </div>
        <app-analytics-time-selector
          [disabled]="isLoading"
          (selectedOptionChange)="onChildSelectionChange($event)"
        />
      </div>
    </div>

    @if (!isNoContent) {
      <div
        class="my-4 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5"
      >
        <!-- Pie Chart Widget -->
        <div class="md:col-span-1 lg:col-span-1 xl:col-span-1">
          <app-analytics-widget
            [isNoContent]="isNoContent"
            [loading]="isLoading"
            class="h-full w-full"
          >
            @if (hasBarAndTableContent && !isLoading) {
              <app-analytics-apex-chart-pie
                [series]="severityBreakdownData"
                [labels]="severityBreakdownLabels"
                [title]="severityBreakdownTitle"
                (categoryChange)="calculateCategoryMetrics($event)"
              />
            }
          </app-analytics-widget>
        </div>

        <!-- Measurements Widget -->
        <div class="md:col-span-1 lg:col-span-1 xl:col-span-1">
          <app-analytics-widget
            [isNoContent]="isNoContent"
            [loading]="isLoading"
            class="h-full w-full"
          >
            @if (hasBarAndTableContent && !isLoading) {
              <app-highlighted-network-measurements
                [category]="measurementCategory"
                [dataUtilization]="dataUtilization"
                [latency]="latency"
                [jitter]="jitter"
                [packetLost]="packetLost"
                class="h-full w-full"
              />
            }
          </app-analytics-widget>
        </div>

        <!-- Bar Chart Widget -->
        <div class="md:col-span-2 lg:col-span-2 xl:col-span-3">
          <app-analytics-widget
            [isNoContent]="isNoContent"
            [loading]="isLoading"
            class="h-full w-full"
          >
            @if (!isLoading) {
              <app-analytics-apex-chart-bar
                [chartName]="topUnusualDevicesTitle"
                [data]="topUnusualDevicesData"
                [categories]="topUnusualDevicesCategories"
                [yTitle]="topUnusualDevicesYtitle"
              ></app-analytics-apex-chart-bar>
            }
          </app-analytics-widget>
        </div>
      </div>
    }

    @if ((unmRawDeviceEvents$ | async)?.devices?.length && !isLoading) {
      <app-unm-data-table
        [deviceEvents]="(unmRawDeviceEvents$ | async)?.devices"
        [isNoContent]="isNoContent"
        [isLoading]="isLoading"
      />
    } @else {
      <div
        class="my-4 flex h-full flex-col rounded-xl bg-white p-12 md:items-center md:justify-center"
      >
        @if (isLoading) {
          <div class="flex items-center justify-center">
            <mat-spinner [diameter]="75"></mat-spinner>
          </div>
        } @else {
          <h2 class="text-xl font-semibold text-gray-700">
            Summarized Data Not Available
          </h2>
          <p class="mt-2 text-gray-600">
            Insufficient device information to generate observation summaries
            for the selected time frame
          </p>
        }
      </div>
    }
  </div>
</section>
